import {
    GESTION_OPERATIVA_CALCULATE_REMAINING_SUCCESS,
  } from '../constants';
  

  export function reducer(state, action) {
    if (action.type === GESTION_OPERATIVA_CALCULATE_REMAINING_SUCCESS) {
        return {
                ...state,
                maximoDescuento : {
                                    ...state.maximoDescuento,
                                    remainder:action.data.remainder
                },
                saveButtonDisabled: true,
        }
    }
    else {
        return state
    }
          
  }
